import { useSellarSession } from "../../../hooks/useSellarSession";
import { SessionInitializationError } from "../../../components/app/SessionInitializationError";
import { type ReactNode } from "react";
import { PoweredBySellar } from "../../stockList/categoryPage/Storefront/PoweredBySellar";

export const UserSignupFlowContent = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { state } = useSellarSession();
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-auto">
        <div className="flex h-full w-full flex-col">
          {state.status === "initialization-error" ||
          state.status === "retrying-initialization" ? (
            <SessionInitializationError />
          ) : (
            children
          )}
        </div>
      </div>
      <div className="flex shrink-0 justify-center pt-4 pb-8">
        <PoweredBySellar />
      </div>
    </div>
  );
};
